import { render } from "./ToastNotification.vue?vue&type=template&id=0a12c2f2&scoped=true&ts=true"
import script from "./ToastNotification.vue?vue&type=script&lang=ts"
export * from "./ToastNotification.vue?vue&type=script&lang=ts"

import "./ToastNotification.vue?vue&type=style&index=0&id=0a12c2f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a12c2f2"]])

export default __exports__